module.exports = __webpack_public_path__ + "img/ground.402f2336.png";